import { render, staticRenderFns } from "./promotion-analysis.vue?vue&type=template&id=1d3e5e26&scoped=true&"
import script from "./promotion-analysis.vue?vue&type=script&lang=js&"
export * from "./promotion-analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3e5e26",
  null
  
)

export default component.exports